import { palette } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'

const ProgressLineStyled = styled('span')`
  position: absolute;
  bottom: -21px;
  height: 15px;
  width: 1px;
  background-color: transparent;
  border-left: 2px dotted ${palette.black.plus70};
`

export default ProgressLineStyled
